import { addSeconds } from 'date-fns';

import { IHistoricalOrder, IServerOrder } from '@rbi-ctg/menu';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

type PickupTimeOrderLike = {
  updatedAt?: string | null;
  fireOrderIn?: number | null;
};

export const usePickupTime = (
  serverOrder: IServerOrder | IHistoricalOrder | PickupTimeOrderLike | null
) => {
  const fireOrderAhead = useFlag(LaunchDarklyFlag.FIRE_ORDER_AHEAD);

  let pickupDate = new Date();
  if (serverOrder?.updatedAt) {
    pickupDate = new Date(serverOrder?.updatedAt);

    if (!serverOrder.fireOrderIn) {
      return {
        pickupDate,
      };
    }
    //fireOrderAhead were maybe subtracted on injection, add back so user sees what they picked
    pickupDate = addSeconds(pickupDate, serverOrder.fireOrderIn + (fireOrderAhead ?? 0));
  }

  return {
    pickupDate,
  };
};
